import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ActKc2Data, UerCreateActKc2CorrectionMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateActKC2CorrectionGql } from '../../workOrderQueries';

interface IUseUerCreateActKC2Correction {
    onSuccess?: (data?: ActKc2Data) => void;
    primaryActKC2Id: number;
}

const requestId = 'uerCreateActKC2Correction';

export const useUerCreateActKC2Correction = (props: IUseUerCreateActKC2Correction) => {
    const dispatch = useDispatch();
    const { onSuccess, primaryActKC2Id } = props;

    const [uerCreateActKC2CorrectionReset] = useResetStoreData({
        requestId,
    });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<UerCreateActKc2CorrectionMutation>) => {
            if (depsVars?.payload?.uerCreateActKC2Correction?.data) {
                onSuccess?.(depsVars?.payload?.uerCreateActKC2Correction?.data);
            }
            uerCreateActKC2CorrectionReset(undefined);
        },
        [onSuccess, uerCreateActKC2CorrectionReset],
    );

    const [, , , uerCreateActKC2CorrectionRequest] = useRequest<UerCreateActKc2CorrectionMutation>({
        requestId,
        query: uerCreateActKC2CorrectionGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return useCallback(() => {
        dispatch(uerCreateActKC2CorrectionRequest({ primaryActKC2Id }));
    }, [uerCreateActKC2CorrectionRequest, dispatch, primaryActKC2Id]);
};
